
export const ForecastTotals = ({
    totals
}) => {
    return (
        <div className="grid grid-cols-6 gap-4">
            {/* Annual Revenue */}
            <article className="rounded-lg shadow-2xs from-blue-500 to-blue-600 text-white border-0 bg-transparent">
                <div className="p-4 text-[rgba(0,0,0,1)] bg-[rgba(239,246,255,1)] rounded-md border-solid shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">${((totals?.annualRevenue || 0) / 1000000).toFixed(1)}M</h6>
                    <p className="text-sm opacity-90 margin-0">Annual Revenue</p>
                </div>
            </article>
            {/* Units Forecasted */}
            <article className="rounded-lg shadow-2xs from-green-500 to-green-600 text-white border-0 bg-transparent">
                <div className="p-4 bg-[rgba(240,253,244,1)] text-black rounded-md shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">{((totals?.unitsForecasted || 0) / 1000).toFixed(1)}K</h6>
                    <p className="text-sm opacity-90 margin-0">Units Forecasted</p>
                </div>
            </article>
            {/* Contribution Margin */}
            <article className="rounded-lg shadow-2xs bg-gradient-to-br from-purple-500 to-purple-600 text-white border-0">
                <div className="p-4 text-[rgba(3,3,3,1)] bg-[rgba(250,245,255,1)] rounded-md shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">${((totals?.contributionMargin || 0) / 1000000).toFixed(1)}M</h6>
                    <p className="text-sm opacity-90 margin-0">Contribution Margin</p>
                </div>
            </article>
            {/* Blended ROAS */}
            <article className="rounded-lg shadow-2xs from-orange-500 to-orange-600 text-white border-0 bg-transparent">
                <div className="p-4 text-black bg-[rgba(255,247,237,1)] rounded-md shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">{totals?.blendedRoas || 0}</h6>
                    <p className="text-sm opacity-90 margin-0">Blended ROAS</p>
                </div>
            </article>
            {/* Total Ad Spend */}
            <article className="rounded-lg shadow-2xs from-red-500 to-red-600 text-white border-0 bg-transparent">
                <div className="p-4 text-black bg-[rgba(254,242,242,1)] rounded-md shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">${((totals?.totalAdSpend || 0) / 1000000).toFixed(1)}M</h6>
                    <p className="text-sm opacity-90 margin-0">Total Ad Spend</p>
                </div>
            </article>
            {/* MER */}
            <article className="rounded-lg shadow-2xs from-violet-400 to-violet-500 text-white border-0 bg-transparent">
                <div className="p-4 bg-[rgba(238,242,255,1)] text-black rounded-md shadow-lg h-20 flex flex-col justify-center">
                    <h6 className="text-2xl font-bold margin-0">{totals?.efficiencyRatio || 0}</h6>
                    <p className="text-sm opacity-90 margin-0">MER</p>
                </div>
            </article>
        </div>
    )
}